import React from 'react'

const CheckoutContext = React.createContext(null)
CheckoutContext.displayName = 'CheckoutContext'

export default CheckoutContext
